<div class="modal-content">
    <!-- Cabeçalho do Modal com título e botão de fechar -->
    <div class="modal-header">
      <h5 class="modal-title">
        Atualizar Status Projeto
      </h5>
      <button
        type="button"
        class="btn-close"
        aria-label="Fechar"
        (click)="activeModal.dismiss()"
      ></button>
    </div>
  
    <div class="modal-body p-4">
      <form [formGroup]="statusProjetoForm" (ngSubmit)="AtualizarDocumento()">

        <input hidden formControlName="projetoId">

        <div class="mb-3">
            <label for="statusProjeto" class="form-label">
              Selecione o status
            </label><span style="color: red;">*</span>
            <select class="form-select" formControlName="statusProjeto" 
            [ngClass]="{
              'is-invalid':
              statusProjetoForm.controls.statusProjeto.errors &&
              statusProjetoForm.get('statusProjeto')?.touched,
            }"
            >
              <option value="" selected disabled>Selecione um status</option>
              <!-- <option value="0">Briefing</option> -->
              <option value="0">Iniciado</option>
              <option value="1">Aprovado</option>
              <option value="2">Recusado</option>
              <option value="3">Negociando</option>
              <option value="4">Finalizado</option>
            </select>
            <div class="invalid-feedback" *ngIf="statusProjetoForm.controls.statusProjeto.errors">
              Selecione um status
            </div>
          </div>
        <!-- Botão de Enviar -->
        <div class="text-end">
          @if(!isLoading){

            <button type="submit" class="btn btn-success btn-sm w-md">
              Atualizar
            </button>
          }@else{
            <button type="button" class="btn btn-light waves-effect">
              <i class="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i> Trabalhando
          </button>
          }
        </div>
      </form>
    </div>
  </div>
  